import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'

const pinia = createPinia()

// Mount on TecDoc catalog page
const catalogMount = document.getElementById('tecdoc-app')
if (catalogMount) {
  const app = createApp(App, { mode: 'catalog' })
  app.use(pinia)
  app.mount(catalogMount)
}

// Mount on product detail page
const productMount = document.getElementById('tecdoc-product-enrichment')
if (productMount) {
  const sku = productMount.dataset.sku ?? ''
  const app = createApp(App, { mode: 'product', sku })
  app.use(pinia)
  app.mount(productMount)
}
